import { gql, useLazyQuery } from '@apollo/client'

import type { CartInfoInput } from '../types'
import type { RemoteCartInfo } from '@@types'

const CART_INFO_QUERY = gql`
  query CartInfo(
    $cartInfo: CartInfoInput!
    $style: String
    $imageStyle2: String
    $imagesStyle2: String
    $previewStyle2: String
  ) {
    cartInfo(cartInfo: $cartInfo) {
      totalWeight
      promocode
      promocodeType
      priceGroup
      totals {
        count
        baseTotal
        total
        baseSale
        sale
        salePercent
        maxSale
        promoPercent
        effectiveTotal
      }
      delivery {
        total
        sale
        salePercent
        maxSale
        promoPercent
        type
        from
        timeRestrictions {
          from
          to
        }
      }
      products {
        id
        amount
        shop_id
        total
        comment
        info {
          id
          name
          price
          oldPrice
          price_type
          isWeightProduct
          count_multiplier
          isFavorite
          stock {
            amount
          }
          preview(style: $previewStyle2) {
            url
          }
          slug
          review_count
          marketingLabels {
            id
            title
            description
            image(style: "600xauto", type: "webp") {
              url
            }
            activeFrom
            activeUntil
            optionColor
            optionBackgroundColor
            optionLink
            optionLinkLabel
          }
          is_alcohol
          priceOffers {
            id
            price
            oldPrice
            salePeriod {
              start
              finish
            }
            min
            max
            step
            quant
            uiQuant
            quantAmount
            isDefault
            group
          }
          priceOffer @client {
            id
            price
            oldPrice
            count_multiplier
            salePeriod {
              start
              finish
            }
            min
            max
            step
            quant
            quantAmount
            isDefault
            group
          }
        }
      }
      sales {
        salePluginId
        bonusCurrencyId
        amount
        sale
        salePercent
        type
      }
      saleOffers {
        id
        title
        reason
        reasonId
        type
        discount
        maxDiscount
        discountCurrencyId
        salePluginId
      }
    }
  }
`

export interface CartInfoVariables {
  cartInfo: CartInfoInput
  style?: string
  imageStyle2?: string
  imagesStyle2?: string
  previewStyle2?: string
}

export interface CartInfoResponse {
  cartInfo: RemoteCartInfo | null
}

export function useFetchCartInfo () {
  return useLazyQuery<CartInfoResponse, CartInfoVariables>(CART_INFO_QUERY, {
    fetchPolicy: 'network-only',
  })
}
